const SIGNIN_VISIBLE = `signin--visible`
const LOGO_SIGNIN_OPEN = `logo__link--signin-open`

const pageHeader = document.querySelector(`.page-header`)
const signinBlock = pageHeader.querySelector(`.main-nav__item--signin`)
const signinBtn = signinBlock.querySelector(`.signin-btn`)
const signinElement = pageHeader.querySelector(`.signin`)
const mainNavList = pageHeader.querySelector(`.main-nav__list`)
const signinCommonElement = pageHeader.querySelector(`.signin-login-common`) // all page exclude main
const mainNavSignIn = signinBtn.querySelector(`.logo__link--signin`)
const logInTopBtn = pageHeader.querySelector(`.signin-mobile`)
const signinScroll = pageHeader.querySelector(`.signin-scroll`)
const logoSignInClose = signinBtn.querySelector(`.logo__img-close-qr`)
const logoSignInOpen = signinBtn.querySelector(`.logo__img-qr`)
const main = document.querySelector(`.page-content`)

const signinScrollOnClick = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: `smooth`,
  })
  if (!signinElement.classList.contains(SIGNIN_VISIBLE)) {
    signinElement.classList.toggle(SIGNIN_VISIBLE)
  }
}

const isIOS = navigator.userAgent.match(/iPhone|iPod|iPad/i)
|| (navigator.userAgent.match(/Intel Mac OS X/i) && navigator.maxTouchPoints > 1) // crazy ios13 on iPad..

const mobileDevice = isIOS || navigator.userAgent.match(/Android/i)

if (mobileDevice) {
  signinElement.classList.add(`mobile`)
  pageHeader.classList.add(`page-header--mobile`)

  if (logInTopBtn) {
    logInTopBtn.style.display = `inline-block`
  }
  if (signinScroll) {
    signinScroll.classList.remove(`signin-scroll`)
    signinScroll.classList.add(`signin-mobile`)
  }

} else {
  signinElement.classList.add(`desktop`)
  if (logInTopBtn) {
    logInTopBtn.style.display = `none`
  }
  if (signinScroll) {
    signinScroll.addEventListener(`click`, signinScrollOnClick)
  }
}

const checkBanner = () => {
  const banner = pageHeader.querySelector(`.banner`)

  if (banner) {
    signinElement.classList.add('signin--with-banner')
  } else {
    signinElement.classList.remove('signin--with-banner')
  }
}

const signinCloseOnClick = (evt) => {
  evt.preventDefault()
  evt.stopPropagation()
  
  checkBanner()

  const headerMobile = pageHeader.classList.contains(`page-header--mobile`)

  if (headerMobile) {
    // pageHeader.style.position = `relative`
    pageHeader.classList.remove(`page-header--fixed`)
  }

  signinBtn.removeEventListener(`click`, signinCloseOnClick)
  mainNavList.classList.remove(`main-nav__list--dark`)
  signinElement.classList.remove(SIGNIN_VISIBLE)
  mainNavSignIn.classList.remove(LOGO_SIGNIN_OPEN)
  if (logoSignInClose) {
    logoSignInClose.style.display = `none`
  }
  logoSignInOpen.style.display = `block`
}

const singinBtnOnClick = (evt) => {
  evt.preventDefault()
  
  checkBanner()

  const headerMobile = pageHeader.classList.contains(`page-header--mobile`)
  const burgerClose = document.querySelector(`.logo__burger--close`)

  if (headerMobile) {
    // pageHeader.style.position = `fixed`
    pageHeader.classList.add(`page-header--fixed`)
  }

  if (burgerClose) {
    burgerClose.click()
  }

  signinBtn.addEventListener(`click`, signinCloseOnClick)
  mainNavList.classList.add(`main-nav__list--dark`)
  signinElement.classList.add(SIGNIN_VISIBLE)
  mainNavSignIn.classList.add(LOGO_SIGNIN_OPEN)
  if (logoSignInClose) {
    logoSignInClose.style.display = `block`
  }
  logoSignInOpen.style.display = `none`
}

if (document.documentElement.clientWidth >= 992 && !signinCommonElement) {
  signinElement.classList.add(SIGNIN_VISIBLE)
  mainNavSignIn.classList.add(LOGO_SIGNIN_OPEN)
  signinBtn.addEventListener(`click`, signinCloseOnClick)
} else {
  signinBtn.addEventListener(`click`, singinBtnOnClick)
}

signinBtn.addEventListener(`click`, singinBtnOnClick)